var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { BuildStatus } from '../../../../../enums/build-status';
import { WorkflowService } from '../../../../../services/workload/workflow.service';
import { FormService } from '../../../../../services/workload/form.service';
var FormCompleteComponent = /** @class */ (function () {
    function FormCompleteComponent(workflowService, formService, toastr) {
        this.workflowService = workflowService;
        this.formService = formService;
        this.toastr = toastr;
        this.formUnlocked = new EventEmitter();
        this.viewModel = {
            pageTitle: 'Completed Request',
            completedRequest: null,
            displayUnlockForm: false,
            unlockForm: {
                title: 'Unlock Form',
                reasonForUnlocking: ''
            },
            formStatesValues: {
                research: BuildStatus.Research,
                build: BuildStatus.Input,
                compare: BuildStatus.Comparison,
                approve: BuildStatus.Approval,
                amend: BuildStatus.Amend,
                live: BuildStatus.Live,
                readOnlyFormStates: [
                    BuildStatus.Research,
                    BuildStatus.Input,
                    BuildStatus.Comparison,
                    BuildStatus.Approval,
                    BuildStatus.Amend,
                    BuildStatus.Live
                ]
            }
        };
        this.requestId = Input('requestId');
    }
    FormCompleteComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.workflowService.getRequestById(this.requestId).then(function (requestData) {
            _this.viewModel.completedRequest = requestData;
        });
    };
    FormCompleteComponent.prototype.displayUnlockForm = function (show) {
        if (!show) {
            this.viewModel.unlockForm.reasonForUnlocking = '';
        }
        this.viewModel.displayUnlockForm = show;
    };
    FormCompleteComponent.prototype.unlockForm = function () {
        var _this = this;
        if (this.isFormValid()) {
            var unlockData = {
                requestId: this.requestId,
                unlockFeedback: this.viewModel.unlockForm.reasonForUnlocking
            };
            this.formService.unlock(unlockData).then(function (x) { return _this.formUnlocked.emit(BuildStatus.Amend); }, function (error) { return _this.showErrorToastr("Unable to process request - " + error.error); });
        }
        else {
            this.showErrorToastr('Please enter a reason for unlocking');
        }
    };
    FormCompleteComponent.prototype.isFormValid = function () {
        return this.viewModel.unlockForm.reasonForUnlocking.trim().length > 10;
    };
    FormCompleteComponent.prototype.showErrorToastr = function (message) {
        this.toastr.error(message, 'Error!', {
            timeOut: 5000,
            positionClass: 'toast-bottom-right'
        });
    };
    __decorate([
        Output(),
        __metadata("design:type", Object)
    ], FormCompleteComponent.prototype, "formUnlocked", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Number)
    ], FormCompleteComponent.prototype, "requestId", void 0);
    FormCompleteComponent = __decorate([
        Component({
            selector: 'form-complete',
            template: require('./form-complete.component.html'),
            styles: [require('./form-complete.component.scss')]
        }),
        __metadata("design:paramtypes", [WorkflowService, FormService, ToastrService])
    ], FormCompleteComponent);
    return FormCompleteComponent;
}());
export { FormCompleteComponent };
//# sourceMappingURL=data:application/json;base64,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